import { render, staticRenderFns } from "./scraping_core.vue?vue&type=template&id=c4c67b4a&scoped=true"
import script from "./scraping_core.vue?vue&type=script&lang=js"
export * from "./scraping_core.vue?vue&type=script&lang=js"
import style0 from "./scraping_core.vue?vue&type=style&index=0&id=c4c67b4a&prod&scoped=true&lang=css"
import style1 from "./scraping_core.vue?vue&type=style&index=1&id=c4c67b4a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4c67b4a",
  null
  
)

export default component.exports